import header from "./header";
import footer from "./footer";
import loginAndSignUp from "./loginAndSignUp";
import profile from "./personalCenter/profile";
import history from "./personalCenter/history";
import setting from "./personalCenter/setting";
import siderBar from "./personalCenter/siderBar";
import common from "./common";
import purchase from "./purchase"

const lang = {
	header: {
		...header,
	},
	footer: {
		...footer,
	},
	loginAndSignUp: {
		...loginAndSignUp,
	},
	personalCenterSiderBar: {
		...siderBar,
	},
	personalCenterProfile: {
		...profile,
	},
	personalCenterHistory: {
		...history
	},
	personalCenterSetting: {
		...setting
	},
	common: {
		...common,
	},
	purchase:{
		...purchase
	}
};

export default lang;
